export class Team {
  constructor() {
    this.id = "";
    this.name = "";
    this.createdBy = "";
  }
}
